import React, { useState, useEffect, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { ThinCheckbox } from 'components/common/Styles';

const RefineAuthorizationListResponsiveTableRowCell = ({ dispatch, authorization, documentState, userGroup, changedRefinePermission }) => {
  const [localValue, setLocalValue] = useState(false);

  useEffect(() => {
    if (changedRefinePermission !== undefined) {
      setLocalValue(changedRefinePermission);
    }
  }, [changedRefinePermission]);

  useEffect(() => {
    if (changedRefinePermission === undefined)
      setLocalValue(
        authorization?.authorizationXDocumentTypeXUserGroups?.find(
          x =>
            x.documentTypeId === documentState.documentTypeId &&
            x.documentStateId === documentState.documentStateId &&
            x.userGroupId === userGroup.id
        )?.canRead || false
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorization?.authorizationXDocumentTypeXUserGroups, documentState.documentStateId, documentState.documentTypeId, userGroup.id]);

  const onClickExecution = useCallback(
    event => {
      dispatch({
        type: 'OnSetAuthorizationXDocumentTypeXUserGroupValue',
        documentStateId: documentState.documentStateId,
        userGroupId: userGroup.id,
        documentTypeId: documentState.documentTypeId,
        value: event.target.checked
      });
    },
    [dispatch, documentState.documentStateId, documentState.documentTypeId, userGroup.id]
  );

  return (
    <TableCell align='center'>
      <ThinCheckbox checked={localValue} size='small' onClick={event => onClickExecution(event)} />
    </TableCell>
  );
};

RefineAuthorizationListResponsiveTableRowCell.propTypes = {
  changedRefinePermission: PropTypes.bool,
  userGroup: PropTypes.object.isRequired,
  documentState: PropTypes.object.isRequired,
  authorization: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default memo(RefineAuthorizationListResponsiveTableRowCell);
